import { SvgIcon } from '@mui/material';
import React from 'react';

/**
 * Logo Teract – logo officiel avec couleurs vert et noir.
 * Source : teract.svg (couleurs officielles #0a221c noir, #7de29f vert).
 */
const TeractIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 1552 268" {...props}>
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
          <path d="m-536-511h9707v5462h-9707z" />
        </clipPath>
      </defs>
      <g clipPath="url(#cp1)">
        <path
          fill="#0a221c"
          d="m931.9 75.7l-34.2-71.1-127.5 257.2h69.7z"
        />
        <path
          fill="#7de29f"
          d="m918.1 150h-17l40.1 78.4c10.5 20.3 33.8 33.4 60.1 33.2h22.9l-37.8-74c-11.8-23.1-38.3-37.8-68.1-37.8z"
        />
        <path
          fillRule="evenodd"
          fill="#0a221c"
          d="m1.1 11.2h224v50.8h-81.1v199.8h-61.6v-199.8h-81.3zm337.3 199.8h125.6v50.8h-187.2v-250.6h183.9v50.8h-122.3v48.7h104.8v46.9h-104.8zm365.6-60.4c-4 4-8.2 7.6-12.4 10.5l50 100.7h-69.8l-40.1-80.9c-5.3 0-51.3 0-52.7 0v80.9h-61.6v-250.4h119.5c12.9 0 24.6 2.4 35.3 7.3 10.8 4.9 20 11.5 27.6 19.4 7.7 7.9 13.6 17 18 27.1 4.4 10.1 6.5 20.9 6.5 31 0 10.1-1.8 19.8-5.4 29.3-3.6 9.5-8.2 18.2-15.1 25.1zm-68.6-20.5c4.9 0 9.3-1.4 13.1-4.2 4-3 7.1-6.9 9.6-12.1 2.6-5.1 3.8-11 3.8-17.6 0-7.1-1.4-13-4.4-18.2-2.9-5.1-6.5-9.1-10.9-11.8-4.2-2.8-8.8-4.2-13.2-4.2h-54.5v68.1zm913.9-118.9v50.8h-81.2v199.8h-61.5v-199.8h-81.3v-50.8zm-329.9 186.1c6.5-5.3 11.5-12 15.1-20.5l50.6 28.2c-5.4 12.3-14.2 22.8-26.2 31.5-12 8.7-25.6 15.4-40.6 20-14.9 4.5-30 6.9-44.9 6.9-19.4 0-37-3.8-53-11.1q-23.9-11.3-41.6-29.7c-11.8-12.4-20.8-26.3-27.1-41.7-6.5-15.4-9.7-31-9.7-47.1 0-15 3-30 8.9-44.7 5.9-14.6 14.7-28.1 26.2-40.1 11.8-12.1 25.7-21.8 42.3-28.9 16.6-7.1 35.1-10.7 55.8-10.7 25.1 0 46.9 5.1 65.2 15.2 18.3 10.1 32.1 23.4 41.4 39.6l-47.7 31.4c-3.8-8.9-8.8-15.8-15.6-20.9-6.7-5.2-14-8.7-21.8-10.7-8-2-15.6-3-23.1-3-11.6 0-21.7 2.2-30.5 6.6-8.8 4.3-16.2 10-21.8 17.4-5.9 7.3-10.1 15.4-13.1 24.3-2.9 8.9-4.4 17.8-4.4 26.5 0 10.1 1.7 19.8 5.1 28.9 3.3 9.1 8.1 17.2 14.2 24.3 6.1 7.1 13.5 12.7 22.1 16.8 8.6 4.2 18.3 6.2 29 6.2 7.6 0 15.1-1.2 22.9-3.4 7.8-2.2 14.9-5.9 21.6-11.1z"
        />
      </g>
    </SvgIcon>
  );
};

export default TeractIcon;
